import { defineMessages } from "react-intl";

export default defineMessages({
  authCodeInvalid: {
    id: "Auth.AuthContextProvider.authCodeInvalid",
    defaultMessage: "Auth code is invalid",
  },
});
